/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import {
  Box,
  Checkbox,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import * as Sentry from "@sentry/react";
import Button from "../../../../components/common/Button";
import Typography from "../../../../components/common/new/Typography/Typography";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import User from "../../../../services/api/user";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import IntroductionForm from "../../../../services/api/introductionForm";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import { getDropdownOptions } from "../../../../utils";

const BSGRoles = [
  { value: "helpDesk", label: "Help Desk" },
  { value: "emailManager", label: "Email Manager" },
  { value: "areaSI", label: "Area SI" },
  { value: "zoneSI", label: "Zone SI" },
  { value: "regionSI", label: "Region SI" },
  { value: "chapterSI", label: "Chapter SI" },
  { value: "districtSI", label: "District SI" },
  { value: "contributionAdmin", label: "Contribution Admin" },
  { value: "contributionDataEntry", label: "Contribution Data Entry" },
  {
    value: "contributionOfflineDataEntry",
    label: "Contribution Offline Data Entry",
  },
  { value: "nationalSI", label: "National SI" },
  { value: "member", label: "Member" },
];

const GeneralRoles = [
  { value: "areaLeader", label: "Area Leader" },
  { value: "zoneLeader", label: "Zone Leader" },
  { value: "regionLeader", label: "Region Leader" },
  { value: "chapterLeader", label: "Chapter Leader" },
  { value: "districtLeader", label: "District Leader" },
  { value: "blockLeader", label: "Block Leader" },
  { value: "nationalLeader", label: "National Leader" },
];

function MemberRoleModal({ selectedMember, onClose, callBack }) {
  const { assignedRoles, memberId, chapterId, proxyRoles } = selectedMember;
  const rolesAssignedToMember = assignedRoles?.map((allRoles) => {
    return allRoles;
  });

  const toast = useContext(ToastAlertContext);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [districts, setDistricts] = useState([]);

  const [districtIds, setDistrictIds] = useState([]);

  console.log("matchingValues", districtIds);

  const findMatchedKey = () => {
    const matchedItems = districts.filter((item) =>
      districtIds.includes(item.value)
    );
    const matchedKeys = matchedItems.map((item) => item.key);
    return matchedKeys.join(", ");
  };

  console.log("cheifSiOptions", districts);

  useEffect(() => {
    const defaultSelectedBoxes = {};
    BSGRoles.forEach((checkbox) => {
      defaultSelectedBoxes[checkbox.value] = rolesAssignedToMember?.includes(
        checkbox.value
      );
    });
    GeneralRoles.forEach((checkbox) => {
      defaultSelectedBoxes[checkbox.value] = rolesAssignedToMember?.includes(
        checkbox.value
      );
    });
    setSelectedCheckboxes(defaultSelectedBoxes);
  }, []);

  const handleChange = (event) => {
    const checkboxValue = event.target.value;
    setSelectedCheckboxes((prevState) => ({
      ...prevState,
      [checkboxValue]: !prevState[checkboxValue],
    }));
  };

  const selectedRoles = Object.keys(selectedCheckboxes).filter(
    (k) => selectedCheckboxes[k]
  );

  const resultString = new Set(selectedRoles);

  const deleteRoles = rolesAssignedToMember.filter(
    (item) => !resultString.has(item)
  );

  const fetchOptions = async () => {
    try {
      if (rolesAssignedToMember.includes("chapterSI")) {
        const { data } = await IntroductionForm.getAllDistricts({
          data: { chapterId },
        });
        setDistricts(getDropdownOptions(data, "name", "structureId"));
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    try {
      await User.updateRoles(
        {
          rolesToBeDeleted: deleteRoles,
          rolesToBeAssigned: selectedRoles,
          proxyRoles: { districtIds },
        },
        memberId
      );
      toast.show("Roles Updated Successfully", AlertStatus.SUCCESS);

      setTimeout(() => {
        onClose();
        callBack();
      }, 2000);
    } catch (error) {
      Sentry.captureException(error);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  useEffect(() => {
    const proxyStructureIds = proxyRoles?.map((item) => item?.structureId);

    const initialDistrictIds = districts
      .filter((district) => proxyStructureIds?.includes(district?.value))
      ?.map((district) => district?.value);

    setDistrictIds(initialDistrictIds); // Set districtIds after districts is set
  }, [districts]);

  useEffect(() => {
    fetchOptions();
  }, []);

  return (
    <form onSubmit={onSubmit}>
      <Box style={{ display: "flex" }}>
        <Typography variant="title2" color="#8c8c8c">
          User Roles
        </Typography>
        <div
          style={{
            position: "relative",
            float: "right",
            top: "-8px",
            marginLeft: "auto",
          }}
        >
          <IconButton>
            <CloseIcon onClick={onClose} />
          </IconButton>
        </div>
      </Box>
      <Box style={{ display: "flex" }}>
        <Box
          style={{
            boxShadow: "6px 6px 10px #0000001A",
            width: "100%",
          }}
        >
          <List
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
            subheader={<ListSubheader>BDS General Roles</ListSubheader>}
          >
            {BSGRoles.map((roles) => {
              return (
                <ListItem
                  key={roles}
                  secondaryAction={
                    <Checkbox
                      edge="end"
                      value={roles.value}
                      onChange={handleChange}
                      checked={selectedCheckboxes[roles.value] || false}
                      inputProps={{
                        "aria-labelledby": "labelId",
                      }}
                    />
                  }
                >
                  <ListItemButton sx={{ paddingTop: 0 }}>
                    <ListItemText id="labelId" primary={roles.label} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
        <Box
          ml={5}
          style={{
            boxShadow: "6px 6px 10px #0000001A",
            width: "100%",
          }}
        >
          <List
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
            subheader={<ListSubheader>BDS View Roles</ListSubheader>}
          >
            {GeneralRoles.map((roles) => {
              return (
                <ListItem
                  key={roles}
                  secondaryAction={
                    <Checkbox
                      edge="end"
                      value={roles.value}
                      onChange={handleChange}
                      checked={selectedCheckboxes[roles.value] || false}
                      inputProps={{
                        "aria-labelledby": "labelId",
                      }}
                    />
                  }
                >
                  <ListItemButton sx={{ paddingTop: 0 }}>
                    <ListItemText id="labelId" primary={roles.label} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
        {rolesAssignedToMember.includes("chapterSI") && (
          <Box
            ml={5}
            style={{
              boxShadow: "6px 6px 10px #0000001A",
              width: "100%",
              maxWidth: "250px",
            }}
          >
            <Box style={{ marginTop: "0.7rem" }}>
              <Typography
                fontSize="14px"
                color="rgba(0, 0, 0, 0.6)"
                fontWeight={500}
              >
                Proxy Roles
              </Typography>
            </Box>

            <Box style={{ marginTop: "2rem", marginRight: "1rem" }}>
              <Dropdown
                multiple
                label="Select District"
                name="districtIds"
                value={districtIds}
                options={districts}
                onChange={(e) => {
                  setDistrictIds(e.target.value);
                }}
              />
            </Box>
            <Box style={{ marginTop: "2rem" }}>
              <Typography
                fontSize="14px"
                color="rgba(0, 0, 0, 0.6)"
                fontWeight={500}
              >
                Selected District:{" "}
              </Typography>

              <Typography color="rgba(0, 0, 0, 0.6)" fontWeight={600}>
                {findMatchedKey()}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
      <Box style={{ display: "flex", gap: 16 }}>
        <Button
          style={CommonStyles.buttonStyle}
          variant="contained"
          type="submit"
          label="SAVE"
        />
        <Button
          style={CommonStyles.buttonStyle}
          variant="outlined"
          onClick={onClose}
          label="CANCEL"
        />
      </Box>
    </form>
  );
}

export default MemberRoleModal;
